import { RefObject, useEffect, useRef } from 'react';

export const useParentOf = <T extends HTMLElement>(target: RefObject<T>) => {

    const parentRef = useRef(target.current?.parentElement ?? null);

    useEffect(() => {
        if (target.current) {
            parentRef.current = target.current.parentElement;
        }
    }, [target]);

    return parentRef;
};